<div class="wrap-x overflow-hidden multi-column-banner animation-long"
     [class.animation-reveal]="canAnimate"
     [gsap]
     [gsapOff]="!canAnimate"
     [scrollTrigger]="{ start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true }">
    <div [ngClass]="['p-r-' + (component.wrap_padding || 0), 'p-l-' + (component.wrap_padding || 0)]"
         [grid]="component.items.length"
         [gridColumnGap]="component.grid_gap">
        @for (item of component.items; track $index) {
        <div>
            <div class="ratio-1-1 ratio-3-4-s">
                <href [link]="item.cta_link"
                      [hrefClass]="'rf'">
                    <div class="rf overflow-hidden">
                        <div class="rf overflow-hidden">
                            <!-- placeholder -->
                            @if (!item.image && item.video_id) {
                            <shell />
                            }

                            <!-- image -->
                            @if (item.image) {
                            <img class="z-2 animation-zoom-in animation-on-hover bg-col-w"
                                 [dfImage]="item.image"
                                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                                 [ratio]="client.isS ? '3/4' : '1/1'"
                                 fill>
                            }

                            <!-- video -->
                            @if (item.video_id) {
                            <local-vimeo-player class="rf z-3 bg-col-w"
                                                [video-id]="item.video_id"
                                                [autoplay-in-viewport]="true"
                                                [background]="true"
                                                [controls]="false"
                                                [muted]="true"
                                                [loop]="true" />
                            }
                        </div>

                        <!-- button -->
                        @if (item.cta_text || item.cta_title) {
                        <div class="pos-absolute bottom-2 left-3 z-4">
                            <p class="p-b-2"
                               [ngClass]="item.cta_title_text_color || ''"
                               *iCms="'cta_title' of item"></p>
                            <button [ngClass]="item.cta_style || 'button-inline'"
                                    type="button">
                                <span [ngClass]="item.cta_text_color || ''"
                                      *iCms="'cta_text' of item"></span>
                                @if (item.display_arrow) {
                                <span [ngClass]="item.cta_text_color || ''"
                                      class="p-l-1 icon-arrow-forward"></span>
                                }
                            </button>
                        </div>
                        }
                    </div>
                </href>
            </div>
            @if (item.title) {
            <div class="p-t-2 p-l-1-l p-l-1-m p-l-3-s p-r-3-s"
                 [ngClass]="item.text_align || ''">
                <p class="p-b-2 h3"
                   [ngClass]="item.title_text_color || ''"
                   *iCms="'title' of item"></p>
                <href [link]="item.cta_link_1">
                    <button [ngClass]="[item.cta_style_1 || 'button-inline', item.cta_text_1_color || '']"
                            type="button">
                        <span cmsField="multi-column-banner-v1.items"
                              [ngClass]="item.cta_text_1_color || ''"
                              *iCms="'cta_text_1' of item"></span>
                        @if (item.display_arrow_1) {
                        <span [ngClass]="item.cta_text_1_color || ''"
                              class="p-l-1 icon-arrow-forward"></span>
                        }
                    </button>
                </href>
            </div>
            }
        </div>
        }
    </div>
</div>